export const AUDIT_ENGINE_ROUTE_PATHS = {
  auditEngine: '/audit-engine',
};
